import './assets/main.css'
import 'vant/lib/index.css'; // 引入 Vant 样式
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import VueWechatTitle from 'vue-wechat-title'; //引入VueWechatTitle
import 'amfe-flexible'
import Vant from 'vant';

const app = createApp(App)
app.use(Vant);
app.use(router)
app.use(VueWechatTitle)
app.mount('#app')
